module.exports = __webpack_public_path__ + "img/lazer.efe32846.svg";